import type { FC, ReactNode } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import { useSignOut } from "@/partner/entities/auth";

interface AccessGateScreenProps {
  title: ReactNode;
  text?: ReactNode;
}

/**
 * Полноэкранная заглушка гейтов кабинета (не партнёр / нет организации),
 * аналог SignOut-экрана референса: карточка по центру + выход.
 */
export const AccessGateScreen: FC<AccessGateScreenProps> = ({
  title,
  text,
}) => {
  const { t } = useTranslation();
  const [signOut, { loading }] = useSignOut();

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Card elevation={24} sx={{ maxWidth: 420, width: "100%" }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            {title}
          </Typography>
          {text && (
            <Typography variant="body2" color="text.secondary">
              {text}
            </Typography>
          )}
        </CardContent>
        <CardContent>
          <Button
            disableElevation
            size="large"
            color="primary"
            variant="contained"
            fullWidth
            disabled={loading}
            onClick={() => signOut()}
          >
            {t("auth.gate.signOut")}
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};
